import React from 'react'
import { V4_T } from './propertyDetailHelpers'

const cardStyle = { background: 'rgba(251,248,241,0.96)', border: `1px solid ${V4_T.line}`, borderRadius: 12, padding: '14px 16px', minWidth: 260, boxShadow: '0 2px 10px rgba(28,36,25,0.08)' }
const headerStyle = { fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', color: V4_T.mute, marginBottom: 8, fontFamily: 'monospace' }
const mutedStyle = { fontSize: 12, color: V4_T.mute }

const UNAVAILABLE_NOTES = {
  unmatched: 'Portal comparison unavailable — property not matched to a jobsite.',
  no_client: 'Portal comparison unavailable — jobsite has no customer.'
}

// Billing recipients (Aspire invoice contacts) plus a one-way reconciliation
// warning: legacy portal contacts with receiveInvoices=true whose email is
// not on the Aspire list. Presentational — PropertyReviewModal owns the fetch.
function InvoiceContactsCard ({ data, error }) {
  if (error) {
    return (
      <div style={cardStyle}>
        <div style={headerStyle}>BILLING RECIPIENTS</div>
        <div style={mutedStyle}>Couldn’t load billing contacts.</div>
      </div>
    )
  }
  if (!data) return null
  const recipients = Array.isArray(data.aspireInvoiceRecipients) ? data.aspireInvoiceRecipients : []
  const missing = Array.isArray(data.missingLegacyContacts) ? data.missingLegacyContacts : []
  const unavailableNote = data.legacyComparison === 'unavailable'
    ? (UNAVAILABLE_NOTES[data.unavailableReason] || 'Portal comparison unavailable.')
    : null
  return (
    <div style={cardStyle}>
      <div style={headerStyle}>{`BILLING RECIPIENTS · ${recipients.length}`}</div>
      {recipients.length === 0 && <div style={mutedStyle}>No invoice contacts flagged in Aspire.</div>}
      {recipients.map(r => (
        <div key={r.contactId ?? r.name} style={{ display: 'flex', alignItems: 'baseline', gap: 8, padding: '3px 0' }}>
          <span style={{ fontSize: 13, color: V4_T.ink2, fontWeight: 600 }}>{r.name}</span>
          {r.email
            ? <span style={{ fontSize: 12, color: V4_T.mute, fontFamily: 'monospace' }}>{r.email}</span>
            : <span style={{ ...mutedStyle, fontStyle: 'italic' }}>no email</span>}
        </div>
      ))}
      {unavailableNote && <div style={{ ...mutedStyle, marginTop: 6 }}>{unavailableNote}</div>}
      {missing.length > 0 && (
        <div style={{ marginTop: 10, padding: '10px 12px', borderRadius: 8, border: `1.5px solid ${V4_T.rust}`, background: 'rgba(193,102,44,0.07)' }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.06em', color: V4_T.rust, textTransform: 'uppercase' }}>
            {`${missing.length} portal invoice contact${missing.length === 1 ? '' : 's'} not receiving Aspire invoices`}
          </div>
          {missing.map(c => (
            <div key={c.contactId} style={{ fontSize: 12.5, color: V4_T.ink, marginTop: 5 }}>
              {`${c.name} · ${c.email}`}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default InvoiceContactsCard
